module KendoWidgets
{
	export class VrRating extends kendo.ui.Widget implements KendoWidget
	{
		controlType(): ControlTypeEnum { return ControlTypeEnum.VrRating; }

		private _options: VrRatingOptions | undefined;
		private _value: number;
		private _hovering: number | null;
		private _readOnly: boolean;
		private _firstLoad: boolean;

		//#region Inner controls
		private _stars: JQuery[];
		private _lblValue: Label | null;
		//#endregion

		constructor(element: Element, options?: VrRatingOptions)
		{
			if (options == null)
				options = new VrRatingOptions();

			super(element, options);
			this._options = options;

			this.draw();
		}

		private draw()
		{
			let starCount: number;
			if (this._options == null || this._options.starCount == null)
				starCount = 5;
			else starCount = this._options.starCount;

			let starSize: number;
			if (this._options != null && this._options.starSize != null)
				starSize = this._options.starSize;
			else starSize = 25;

			let pts = [5, 40, 95, 40, 20, 95, 50, 5, 80, 95];

			if (starSize != 100)
				pts = pts.map(p => p * starSize / 100);

			this._stars = [];
			for (let i = 0; i < starCount; i++)
			{
				let star = $(`<svg width='${starSize}' height='${starSize}'><path d='M${pts[0]} ${pts[1]} L${pts[2]} ${pts[3]} L${pts[4]} ${pts[5]} L${pts[6]} ${pts[7]} L${pts[8]} ${pts[9]} Z'/></svg>`)
					.appendTo(this.element);

				star.hover(_ =>
				{
					if (!this._readOnly)
					{
						this._hovering = i;
						this.updateHighlights();
					}
				}, _ =>
				{
					if (!this._readOnly)
					{
						this._hovering = null;
						this.updateHighlights();
					}
				});

				star.click(_ =>
				{
					if (!this._readOnly)
						this.value(i + 1);
				});

				this._stars.push(star);
			}

			//#region Value label
			if (this._options != null && this._options.showValueLabel != null && this._options.showValueLabel)
			{
				let randomId = Math.floor(Math.random() * 100000);
				this._lblValue = $("<label id='ratValueLabel" + randomId.toString() + "'>").appendTo(this.element).kendoLabel({
					css: "vertical-align: super; margin-left: 5px; font-weight: 500;",
					fontSize: 16
				}).data("kendoLabel");
			}
			//#endregion

			//#region Label
			let element = this.element[0];

			let label = null;
			if (this._options != null && this._options.label != null && !this._firstLoad)
			{
				this._firstLoad = true;

				$("#" + this.element[0].id + "Label").remove();
				label = document.createElement("label");
				label.id = this.element[0].id + "Label";
				$(label).kendoLabel(
					{
						text: this._options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						height: 20,
						fontSize: 14,
						width: "auto"
					});

				//#region Label position
				if (this._options.labelPosition == null) this._options.labelPosition = LabelPositionEnum.Top;
				switch (this._options.labelPosition)
				{
					case LabelPositionEnum.Top:
						{
							$(label).addClass("k-label-top");
							$(label).css("display", "block");
							$(label).prependTo(element);

							(element as HTMLElement).style.cssText += "width: 100%";
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");
							element.insertBefore(label, element.firstChild);
							label.style.cssText += "margin-right: 5px";
						}
						break;
					case LabelPositionEnum.Right:
						{
							$(label).addClass("k-label-right");
							element.append(label);
							label.style.cssText += "margin-left: 5px";
						}
						break;
					case LabelPositionEnum.Bottom:
						{
							$(label).addClass("k-label-bottom");
							element.style.cssText += "display: inline-flex; flex-direction: column;";
							element.append(label);

							(element as HTMLElement).style.cssText += "width: 100%";
						}
						break;
				}
				//#endregion

				$(element).parent().parent().attr("id", element.id + "Parent");

				if (this._options.readOnly)
					$(element).attr("readonly", "readonly");
			}
			//#endregion

			if (this._options != null && this._options.value != null)
				this.value(this._options.value);
			else this.value(0);

			if (this._options != null && this._options.readOnly != null)
				this.readOnly(this._options.readOnly);
		}

		value(value?: number): number
		{
			if (value != null)
			{
				let oldValue = this._value;

				this._value = value;
				this.updateHighlights(true);
				if (this._lblValue != null)
					this._lblValue.text(value.toDecimalString(2));

				if (this._options != null && this._options.valueChanged != null)
					this._options.valueChanged(oldValue, value);
			}

			return this._value;
		}

		clear()
		{
			this.value(0);
		}

		readOnly(readOnly?: boolean): boolean
		{
			if (readOnly != null)
				this._readOnly = readOnly;

			return this._readOnly;
		}

		private updateHighlights(fromValue: boolean = false)
		{
			let selectedColor: string = "goldenrod";
			let hoverColor: string = "gold";

			if (this._options != null)
			{
				if (this._options.selectedColor != null)
					selectedColor = this._options.selectedColor;

				if (this._options.hoverColor != null)
					hoverColor = this._options.hoverColor;
			}

			let reference: number;
			let highlight: string;
			if (this._hovering != null)
			{
				reference = this._hovering + 1;
				if (fromValue)
					highlight = selectedColor;
				else highlight = hoverColor;
			}
			else
			{
				reference = this._value;
				highlight = selectedColor;
			}

			for (let i = 0; i < this._stars.length; i++)
			{
				let star = this._stars[i];

				if (reference > i)
					star.css("fill", highlight);
				else star.css("fill", "#CCC");
			}
		}
	}

	export class VrRatingOptions
	{
		starCount?: number;
		starSize?: number;
		value?: number;
		readOnly?: boolean;
		showValueLabel?: boolean;

		selectedColor?: string;
		hoverColor?: string;

		label?: string;
		labelPosition?: LabelPositionEnum;

		valueChanged?: (oldValue: number, newValue: number) => void;
	}

	VrRating.fn = VrRating.prototype;
	VrRating.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
	VrRating.fn.options.name = "VrRating";
	kendo.ui.plugin(VrRating);
}

interface JQuery
{
	kendoVrRating(options?: KendoWidgets.VrRatingOptions): JQuery;
	data(key: "kendoVrRating"): KendoWidgets.VrRating;
}